import { Toaster } from '@/components/ui/sonner';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@/context/AuthContext';
import HomePage from '@/pages/HomePage';
import CalculatorPage from '@/pages/CalculatorPage';
import ResultsPage from '@/pages/ResultsPage';
import CompatibilityPage from '@/pages/CompatibilityPage';
import ForecastPage from '@/pages/ForecastPage';
import PaymentSuccessPage from '@/pages/PaymentSuccessPage';
import PaymentCancelPage from '@/pages/PaymentCancelPage';
import PayPalSuccessPage from '@/pages/PayPalSuccessPage';
import RefundPolicyPage from '@/pages/RefundPolicyPage';
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage';
import TermsOfServicePage from '@/pages/TermsOfServicePage';
import MyCirclePage from '@/pages/MyCirclePage';
import NumenaxisNaujienosPage from '@/pages/NumenaxisNaujienosPage';
import FortuneChestPage from '@/pages/FortuneChestPage';
import ProfilePage from '@/pages/ProfilePage';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import OwnerLivePage from '@/pages/OwnerLivePage';
import SSMethodPage from '@/pages/SSMethodPage';
import DiagnosticGamePage from '@/pages/DiagnosticGamePage';
import NumbersMapPage from '@/pages/NumbersMapPage';
import '@/App.css';

function App() {
  return (
    <AuthProvider>
      <div className="App min-h-screen overflow-x-hidden max-w-full">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/skaiciuoti" element={<CalculatorPage />} />
            <Route path="/rezultatai" element={<ResultsPage />} />
            <Route path="/suderinamumas" element={<CompatibilityPage />} />
            <Route path="/prognozes" element={<ForecastPage />} />
            <Route path="/mano-ratas" element={<MyCirclePage />} />
            <Route path="/naujienos" element={<NumenaxisNaujienosPage />} />
            <Route path="/sekmes-skrynia" element={<FortuneChestPage />} />
            <Route path="/profilis" element={<ProfilePage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/owner-live" element={<OwnerLivePage />} />
            <Route path="/ss-metodas" element={<SSMethodPage />} />
            <Route path="/diagnostika" element={<DiagnosticGamePage />} />
            <Route path="/skaiciu-zemelapis" element={<NumbersMapPage />} />
            <Route path="/mokejimas/sekminga" element={<PaymentSuccessPage />} />
            <Route path="/mokejimas/atsaukta" element={<PaymentCancelPage />} />
            <Route path="/paypal-success" element={<PayPalSuccessPage />} />
            <Route path="/grazinimo-politika" element={<RefundPolicyPage />} />
            <Route path="/privatumo-politika" element={<PrivacyPolicyPage />} />
            <Route path="/naudojimosi-salygos" element={<TermsOfServicePage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors duration={1500} />
      </div>
    </AuthProvider>
  );
}

export default App;
